import React from 'react'
import { Form, Field } from 'react-final-form'
import { injectIntl } from 'react-intl'
import { Button } from '@material-ui/core'
import { connect } from 'react-redux'
import MenuItem from '@material-ui/core/MenuItem'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import isEmpty from 'lodash.isempty'
import { Checkbox, Select } from 'components/common/FormInputs'
import Input from 'components/common/Form/Input'
import getValidator, { VALIDATOR_IS_EMPTY } from 'validation'
import messages from './translate'

function LicenseeApplicationCreateForm(props) {
  const {
    formData: { licenseeApplication, licensees, applications },
    intl: { formatMessage },
    onSubmit,
  } = props

  let initialValues = {
    enableInUi: false,
    showInSideBarMenu: false,
    orderNumber: 0,
  }

  if (!isEmpty(licenseeApplication)) {
    initialValues = {
      enableInUi: licenseeApplication.enableInUi,
      showInSideBarMenu: licenseeApplication.showInSideBarMenu,
      orderNumber: licenseeApplication.orderNumber,
    }
  }

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={initialValues}
      render={({ handleSubmit, submitting }) => (
        <form onSubmit={handleSubmit} className="form-basic">
          <div className="form-group">
            <div className="form-group">
              {!isEmpty(licenseeApplication) ? (
                <h6>
                  {formatMessage(messages.application)} -{' '}
                  {licenseeApplication.appName}
                </h6>
              ) : (
                <Field
                  name="application"
                  component={Select}
                  label={formatMessage(messages.application)}
                  disabled={submitting}
                  required
                  formControlProps={{
                    fullWidth: true,
                    required: true,
                  }}
                  validate={getValidator(VALIDATOR_IS_EMPTY)}>
                  {applications
                    .sort(({ name }, { name: nextName }) =>
                      name.localeCompare(nextName),
                    )
                    .map((application, index) => (
                      <MenuItem
                        key={`${application.id}_${index}`}
                        component="li"
                        button
                        value={application.id}>
                        {application.name}
                      </MenuItem>
                    ))}
                </Field>
              )}
            </div>
            <div className="form-group">
              {!isEmpty(licenseeApplication) ? (
                <h6>
                  {formatMessage(messages.licensee)} -{' '}
                  {licenseeApplication.licenseeName}
                </h6>
              ) : (
                <Field
                  name="licensee"
                  component={Select}
                  label={formatMessage(messages.licensee)}
                  disabled={submitting}
                  required
                  formControlProps={{
                    fullWidth: true,
                    required: true,
                  }}
                  validate={getValidator(VALIDATOR_IS_EMPTY)}>
                  {licensees.map((licensee, index) => (
                    <MenuItem
                      key={`${licensee.id}_${index}`}
                      component="li"
                      button
                      value={licensee.id}>
                      {licensee.name}
                    </MenuItem>
                  ))}
                </Field>
              )}
            </div>
            <FormControlLabel
              label={formatMessage(messages.enableInUi)}
              disabled={submitting}
              className="form-group"
              control={
                <Field
                  name="enableInUi"
                  component={Checkbox}
                  type="checkbox"
                  color="primary"
                />
              }
            />
            <FormControlLabel
              label={formatMessage(messages.showInSideBarMenu)}
              disabled={submitting}
              className="form-group"
              control={
                <Field
                  name="showInSideBarMenu"
                  component={Checkbox}
                  type="checkbox"
                  color="primary"
                />
              }
            />
            <Field
              name="orderNumber"
              type="number"
              label={formatMessage(messages.orderNumber)}
              component={Input}
              disabled={submitting}
              required
              validate={getValidator(VALIDATOR_IS_EMPTY)}
            />
          </div>
          <div className="form-group buttons">
            <Button
              href={null}
              type="submit"
              color="primary"
              size="medium"
              variant="contained"
              onClick={handleSubmit}
              disabled={submitting}>
              {formatMessage(messages.saveInfo)}
            </Button>
          </div>
        </form>
      )}
    />
  )
}

export default connect(
  state => ({
    roleLevel: state.getIn(['profile', 'roleLevel']),
    loading: state.getIn(['sisense', 'loading']),
  }),
  null,
)(injectIntl(LicenseeApplicationCreateForm))
